//#region src/third_party_order_provider.ts
var ThirdPartyOrderProvider = /* @__PURE__ */ function(ThirdPartyOrderProvider) {
	ThirdPartyOrderProvider["PaytronixOnlineOrderingWebhook"] = "paytronix-online-ordering-webhook";
	return ThirdPartyOrderProvider;
}(ThirdPartyOrderProvider || {});
//#endregion
export { ThirdPartyOrderProvider };

//# sourceMappingURL=third_party_order_provider.js.map